export const SUBHEADER_TEXT = 'Preview Program Pathways and Resources'
